import { Box, Tooltip } from '@mui/material';
import { MOSAIC_SANDBOX_TEAM_ID } from 'SandboxModule/constants';
import ApiClientManager from 'core/apiClient';

export const checkIsMosaicSandboxTeam = (teamId: number) => {
  return teamId === MOSAIC_SANDBOX_TEAM_ID;
};

/**
 * Checks if the given realmId is the primary realm for the user's auth default tenant.
 * Used to show "DO NOT SHARE" warning on primary/production realms.
 */
export const checkIsPrimaryRealm = ({ realmId }: { realmId: string }) => {
  const authDefaultTenant = ApiClientManager.getAuthDefaultTenant();
  const primaryRealmId = authDefaultTenant?.primaryRealm;
  return realmId === primaryRealmId;
};

export const makeRealmLabel = ({
  realmId,
  teamName,
  showWarningLabel = false,
  tooltip = '',
}: {
  realmId: string;
  teamName: Nullable<string>;
  showWarningLabel?: boolean;
  tooltip?: string;
}) => {
  return (
    <Tooltip title={tooltip}>
      <span>
        <Box>
          {/* prod has no teamName, this condition is intended */}
          {teamName ? `${teamName} (${realmId})` : `${realmId ?? 'Loading...'}`}{' '}
          {checkIsPrimaryRealm({ realmId }) && showWarningLabel ? (
            <Box
              sx={{
                fontSize: '12px',
                color: 'red',
                display: 'inline-block',
              }}
            >
              | DO NOT SHARE
            </Box>
          ) : (
            ''
          )}
        </Box>
      </span>
    </Tooltip>
  );
};
